// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-full {
  width: 100%;
}
.w-auto {
  width: auto;
}
.h-full {
  height: 100%;
}
.h-auto {
  height: auto;
}
.flex-1 {
  flex: 1 1;
}
.dashboard-layout {
  padding: 10px;
}
.dashboard-menu {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
}
.dashboard-menu-layout {
  display: flex;
  flex-direction: row;
  gap: 10px;
}
.title-text {
  text-align: left;
  color: #21134f !important;
  margin: 0 !important;
}
.bar-chart-menu {
  display: flex;
  justify-content: flex-start;
}
.chart-container {
  width: 100%;
}
.select-channel {
  width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboard/style/index.less"],"names":[],"mappings":"AACA;EACE,WAAA;AAAF;AAGA;EACE,WAAA;AADF;AAIA;EACE,YAAA;AAFF;AAKA;EACE,YAAA;AAHF;AAMA;EACE,SAAA;AAJF;AAQA;EACE,aAAA;AANF;AAQA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AANF;AASA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAPF;AASA;EACE,gBAAA;EACA,yBAAA;EACA,oBAAA;AAPF;AASA;EACE,aAAA;EACA,2BAAA;AAPF;AASA;EACE,WAAA;AAPF;AAWA;EACE,YAAA;AATF","sourcesContent":["//pre class\n.w-full {\n  width: 100%;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n//element class\n.dashboard-layout {\n  padding: 10px;\n}\n.dashboard-menu {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.dashboard-menu-layout {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n.title-text {\n  text-align: left;\n  color: #21134f !important;\n  margin: 0 !important;\n}\n.bar-chart-menu {\n  display: flex;\n  justify-content: flex-start;\n}\n.chart-container {\n  width: 100%;\n  // height: 1200px;\n}\n\n.select-channel {\n  width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
